import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onCTAClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/98 backdrop-blur-lg border-b border-gold/10">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20 lg:h-24">
          
          {/* Logo - Links */}
          <div className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_premium-models-7/artifacts/5p8ck1hp_IMG_3039.png"
              alt="Bad Girl's Society"
              className="h-14 lg:h-16 w-auto cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>

          {/* Navigation - Desktop Mitte */}
          <nav className="hidden lg:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide"
            >
              Leistungen
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide"
            >
              Ablauf
            </button>
            <button 
              onClick={() => scrollToSection('tiktok-live')}
              className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide"
            >
              TikTok LIVE
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-white/80 hover:text-gold transition-colors text-sm font-medium tracking-wide"
            >
              FAQ
            </button>
          </nav>

          {/* CTA Button - Desktop Rechts */}
          <div className="hidden lg:flex items-center gap-4">
            <Button 
              onClick={onCTAClick}
              className="bg-accent-red hover:bg-accent-red/90 text-white px-8 py-3 rounded-full text-sm font-semibold tracking-wide transition-all hover:scale-105 shadow-lg shadow-accent-red/20"
            >
              Jetzt bewerben
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden text-gold p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-black/95 border-t border-gold/10 py-6 space-y-4">
            <button 
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-3 text-white/80 hover:text-gold hover:bg-white/5 rounded transition-colors text-sm font-medium"
            >
              Leistungen
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className="block w-full text-left px-4 py-3 text-white/80 hover:text-gold hover:bg-white/5 rounded transition-colors text-sm font-medium"
            >
              Ablauf
            </button>
            <button 
              onClick={() => scrollToSection('tiktok-live')}
              className="block w-full text-left px-4 py-3 text-white/80 hover:text-gold hover:bg-white/5 rounded transition-colors text-sm font-medium"
            >
              TikTok LIVE
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left px-4 py-3 text-white/80 hover:text-gold hover:bg-white/5 rounded transition-colors text-sm font-medium"
            >
              FAQ
            </button>
            <div className="px-4 pt-2">
              <Button 
                onClick={onCTAClick}
                className="w-full bg-accent-red hover:bg-accent-red/90 text-white py-3 rounded-full text-sm font-semibold"
              >
                Jetzt bewerben
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
